// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { cleaningFormId } from './CleaningForm';
import { cleaningFormSectionId } from './CleaningFormSection';
import { cleaningFieldId } from './CleaningField';
import { operatorId } from './Operator';
import { z } from 'zod';
export const cleaningFormFieldId = (z.number());
export const cleaningFormField = z.object({
    id: cleaningFormFieldId,
    form_id: cleaningFormId,
    section_id: cleaningFormSectionId,
    field_id: cleaningFieldId,
    display_order: z.number(),
    help_text: z.string().nullable(),
    placeholder: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const cleaningFormFieldInitializer = z.object({
    id: cleaningFormFieldId.optional(),
    form_id: cleaningFormId,
    section_id: cleaningFormSectionId,
    field_id: cleaningFieldId,
    display_order: z.number().optional(),
    help_text: z.string().optional().nullable(),
    placeholder: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const cleaningFormFieldMutator = z.object({
    id: cleaningFormFieldId.optional(),
    form_id: cleaningFormId.optional(),
    section_id: cleaningFormSectionId.optional(),
    field_id: cleaningFieldId.optional(),
    display_order: z.number().optional(),
    help_text: z.string().optional().nullable(),
    placeholder: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=CleaningFormField.js.map